export default __webpack_public_path__ + "static/media/RECESS.0f9314b1.png";